import { render, staticRenderFns } from "./UpLoadCard.vue?vue&type=template&id=4c8aa25a&scoped=true"
import script from "./UpLoadCard.vue?vue&type=script&lang=js"
export * from "./UpLoadCard.vue?vue&type=script&lang=js"
import style0 from "./UpLoadCard.vue?vue&type=style&index=0&id=4c8aa25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8aa25a",
  null
  
)

export default component.exports